import React, { useEffect } from "react";
import { SubHeaderContainer } from "../style";
import StyledDatePicker from "components/DatePicker";
import Button from "components/Button";
import Dropdown from "components/Dropdown";
import { useLazyQuery } from '@apollo/client';
import { GET_DAILY_RECONCILIATION_REPORTS_BY_FILTER } from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';
import colors from "constants/colors";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";
import { SaveIcon } from "assets/icons";

const SubHeader = ({
  checkInDate,
  checkOutDate,
  setCheckInDate,
  setCheckOutDate,
  dataTypes,
  setDataTypes,
  setReports
}) => {

  const [getDailyReconciliationReportsByFilter, { data: reportsData, loading, error }] = useLazyQuery(GET_DAILY_RECONCILIATION_REPORTS_BY_FILTER, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true
  })

  useEffect(() => {
    if (!reportsData?.dailyReconciliationReport) return;

    setReports(reportsData.dailyReconciliationReport.rows);
  }, [reportsData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  useEffect(() => {
    if (!checkInDate || !checkOutDate) return;

    getDailyReconciliationReportsByFilter({
      variables: {
        filter: {
          mode: "TRANSACTION_DATE",
          range: {
            startDate: checkInDate,
            endDate: checkOutDate,
          },
          transactionTypes: dataTypes,
        },
      },
    });
  }, [checkInDate, checkOutDate, dataTypes, getDailyReconciliationReportsByFilter]);

  const handleFilter = () => {
    if (loading) return;
    getDailyReconciliationReportsByFilter({
      variables: {
        filter: {
          mode: "TRANSACTION_DATE",
          range : {
            startDate: checkInDate,
            endDate: checkOutDate
          },
          transactionTypes: dataTypes
        } 
      }
    })
  };

  const handleExportReport = () => {
    if (loading) return;
    //TODO: add export logic
  };

  return (
    <SubHeaderContainer>
      <div className="filterContainer">
        <div className="datePicker">
          <StyledDatePicker
            dateValue={moment(checkInDate).tz(TIME_ZONE)}
            dateOnChange={setCheckInDate}
            variant="standard"
            placeholder="Select start date"
            additionalstyle={`
              width: 137px;
              
              input{
                height: 25px;
                font-weight: 400;
                padding: 0 26px 0 0;
                border-bottom: 2px solid ${colors.dimGrey};
              }

              .MuiInput-root {
                margin-top: 0;
              }
            `}
          />
        </div>
        <div className="datePicker">
          <StyledDatePicker
            dateValue={moment(checkOutDate).tz(TIME_ZONE)}
            dateOnChange={setCheckOutDate}
            variant="standard"
            placeholder="Select end date"
            additionalstyle={`
              width: 137px;

              input{
                height: 25px;
                font-weight: 400;
                padding: 0 26px 0 0;
                border-bottom: 2px solid ${colors.dimGrey};
              }

              .MuiInput-root {
                margin-top: 0;
              }
            `}
          />
        </div>
        <div className="dataType">
          <span className="title">DATA TYPE:</span>
          <Dropdown
            mainPage
            multiSelection
            options={[
              {label:"Sale", value:"SALE"},
              {label:"Capture", value:"CAPTURE"},
              {label:"Refund", value:"REFUND"},
            ]}
            value={dataTypes}
            onChange={(e) => {
              const newDataTypes = [...dataTypes];
              if (newDataTypes.includes(e)) {
                const index = newDataTypes.indexOf(e);
                newDataTypes.splice(index, 1);
              } else {
                newDataTypes.push(e);
              }
              setDataTypes(newDataTypes);
            }}
            additionalstyle={`
              width: 220px;
              margin: 0 16px;

              .select {
                .selectedResult {
                  background: ${colors.silver};
                }
              }
            `}
          />
        </div>
        <Button
          mainPage
          additionalstyle={`
            width: 64px;
          `}
          onClick={handleFilter}
          data-loading={loading}
        >
          {loading ? null : "Filter"}
        </Button>
      </div>
      <Button
        mainPage
        additionalstyle={`
          width: 146px;
        `}
        onClick={handleExportReport}
        data-loading={loading}
      >
        {loading ? null : (
          <>
            <span>Export Report </span>
            <span>
              <SaveIcon />
            </span>
          </>
        )}
      </Button>
    </SubHeaderContainer>
  );
};

export default SubHeader;
